import { ValueTypes, InputTypes } from 'app/interfaces';

export default {
	key: 'user_action_reason',
	name: 'Nota',
	valueType: ValueTypes.STRING,
	inputType: InputTypes.TEXTAREA
};
